import Alpine from 'alpinejs'
window.Alpine = Alpine

window.$ = window.jQuery = require("jquery");

Alpine.start()

require('./partials/jquery-extensions.js');
require('./partials/main.js');
require('./partials/concertBox.js');
require('./partials/countdown.js');
require('./partials/events.js');
require('./partials/form.js');
require('./partials/payment-redirection.js');
require('./partials/dotpay.js');
require('./partials/promotion-codes.js');
require('./partials/questionnaire.js');
require('./partials/resize-fonts.js');
require('./partials/theme-mode.js');
// require('./partials/select2-wrapper.js');
require('./partials/tickets.js');
require('./partials/vouchers.js');
require('./partials/magnific-popup-wrapper.js');
require('./partials/carousel-gallery.js');